export default __webpack_public_path__ + "static/media/Linkedin.3ab2b651.svg";